import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import 'moment/locale/ru';

export default class MaterialCard extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        // eslint-disable-next-line
        publishTime: PropTypes.object.isRequired, 
        // eslint-disable-next-line
        cover: PropTypes.any,
        href: PropTypes.string.isRequired,

        // eslint-disable-next-line
        className: PropTypes.string,
        // eslint-disable-next-line
        tagClass: PropTypes.string,
        // eslint-disable-next-line
        authors: PropTypes.array
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let thStyles = {
            backgroundImage: `url(${this.props.cover.article})`
        };

        if (this.props.className === 'first_row') {
            thStyles = {};
        } 
        const authorsArr = (this.props.authors) ? this.props.authors.map((authors) => { 
            if (this.props.authors.length > 1) {
                return authors.title;
            }
            if (this.props.authors.length === 0) {
                return null;
            } 
            return authors.title;
        }) : [];
 
        return (
            <div className={`material--card ${this.props.tagClass} ${this.props.className}`}>
                <a href={this.props.href}>
                    <span className="material--image" style={thStyles}>
                        {this.props.className === 'first_row' ? <img src={this.props.cover.article} alt={this.props.title} /> : ''}
                    </span>
                    <span className="material--info">
                        <span className="info--title">{this.props.title}</span>
                        <span className="info--author">{authorsArr.join(', ')}</span>
                        <span className="info--date">{moment(this.props.publishTime.sec * 1000).format('LLL')}</span>
                    </span>
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Materials/MaterialCard.jsx